var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lamp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.449,
    height: 30.448,
    viewBox: "0 0 30.449 30.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M22.762,13.88a8.862,8.862,0,0,1-3.387,6.978,4.259,4.259,0,0,0-1.624,2.55l-.063-.013H10.075l-.089.013A3.86,3.86,0,0,0,8.54,20.972,8.881,8.881,0,1,1,22.762,13.88Z",
    transform: "translate(1.343 1.344)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M13.88,5a9.083,9.083,0,0,0-1.9.2A8.874,8.874,0,0,0,8.54,20.972a3.86,3.86,0,0,1,1.446,2.436l.089-.013h3.806V5h0Z",
    transform: "translate(1.343 1.344)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(22.61 4.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M18.772,6.954A.952.952,0,0,1,18.1,5.329l1.756-1.756A.952.952,0,1,1,21.2,4.919L19.446,6.675A.954.954,0,0,1,18.772,6.954Z",
    transform: "translate(-17.821 -3.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M23.977,13.153H21.495a.952.952,0,1,1,0-1.9h2.483a.952.952,0,1,1,0,1.9Z",
    transform: "translate(-17.09 -1.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M20.528,21.48a.944.944,0,0,1-.672-.279L18.1,19.445A.952.952,0,0,1,19.446,18.1L21.2,19.855a.952.952,0,0,1-.674,1.625Z",
    transform: "translate(-17.821 0.609)",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M16.694,19.513a3.752,3.752,0,0,0-.063.66v2.816a2.231,2.231,0,0,1-2.22,2.22H11.239a2.313,2.313,0,0,1-2.22-2.588V20.375a3.905,3.905,0,0,0-.089-.863l.089-.013h7.612Z",
    transform: "translate(2.399 5.239)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M12.825,19.5H9.019l-.089.013a3.905,3.905,0,0,1,.089.863v2.246a2.313,2.313,0,0,0,2.22,2.588h1.586Z",
    transform: "translate(2.399 5.239)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M12.2,4.386a.952.952,0,0,1-.952-.952V.952a.952.952,0,1,1,1.9,0V3.434A.952.952,0,0,1,12.2,4.386Z",
    transform: "translate(3.023)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M12.2,0a.952.952,0,0,0-.952.952V3.434a.952.952,0,0,0,.952.952Z",
    transform: "translate(3.023)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M6,6.954a.944.944,0,0,1-.672-.279L3.574,4.919A.952.952,0,1,1,4.92,3.573L6.676,5.329A.952.952,0,0,1,6,6.954Z",
    transform: "translate(0.885 0.885)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M3.574,3.515a.952.952,0,0,0,0,1.346L5.33,6.617a.949.949,0,0,0,1.345,0Z",
    transform: "translate(0.885 0.944)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M3.434,13.153H.952a.952.952,0,1,1,0-1.9H3.434a.952.952,0,1,1,0,1.9Z",
    transform: "translate(0 3.023)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M4.386,12H0a.952.952,0,0,0,.952.952H3.434A.952.952,0,0,0,4.386,12Z",
    transform: "translate(0 3.224)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M4.246,21.48a.952.952,0,0,1-.672-1.625L5.33,18.1a.952.952,0,0,1,1.346,1.346L4.92,21.2A.949.949,0,0,1,4.246,21.48Z",
    transform: "translate(0.885 4.788)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M6.616,18.041l-3.1,3.1a.949.949,0,0,0,1.345,0l1.756-1.756a.95.95,0,0,0,0-1.345Z",
    transform: "translate(0.944 4.847)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M16.892,13.843a.952.952,0,0,1-.952-.952A3.492,3.492,0,0,0,12.452,9.4a.952.952,0,0,1,0-1.9,5.4,5.4,0,0,1,5.392,5.392A.952.952,0,0,1,16.892,13.843Z",
    transform: "translate(3.09 2.015)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M11.8,8.246c-.1,0-.2,0-.3.005a.952.952,0,0,0,.952.952,3.492,3.492,0,0,1,3.489,3.489.952.952,0,0,0,.952.952C17.417,13.643,17.6,8.246,11.8,8.246Z",
    transform: "translate(3.09 2.216)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalIcon);
export default __webpack_public_path__ + "static/media/goalIcon.35a2cf44a0d719be272b508955e99149.svg";
export { ForwardRef as ReactComponent };